import * as React from "react";
import * as learn from "./style.module.scss";
import * as main from "../../main.module.scss";
import { Modal } from "../../../../Modal";
export const Learn = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={`${learn.learn} ${main.hugs}`}>
      <div className="container">
        <div className={`${main.container} ${main.violet}`}>
          <h2 className={main.title}>На мастер классе мы расскажем:</h2>
          <div className={learn.wrap}>
            <ul>
              <li>Как работает механизм выбора профессий</li>
              <li>Роль генов и наследственности, роль воспитания и роль школы</li>
              <li>Как мягко повлиять на выбор профессии ребёнком</li>
              <li>В каких случаях не стоит влиять на выбор ребёнка, а в каких случаях это нужно обязательно</li>
            </ul>
            <div className={learn.img}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/photo-1.png" alt=""/>
            </div>
          </div>
          <div className={`${learn.wrap} ${learn.left}`}>
            <div className={learn.img}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/photo-2.png" alt=""/>
            </div>
            <ul>
              <li>Почему одни с радостью продолжают семейные династии, а другие категорически против профессии родителей</li>
              <li>Как говорить о профориентации с детьми разных возрастов</li>
              <li>Типовые ошибки и способы их решения</li>
              <li>В каком возрасте ребёнку надо начать определяться с профессией и профилем обучения, а в каком надо уже знать точно</li>
            </ul>
          </div>
          <div className={learn.wrap}>
            <ul>
              <li>Что делать, если ребёнок выбрал профессию, которая вам не нравится</li>
              <li>И что делать, если ребёнок вообще ничего не может выбрать</li>
              <li>Какие есть способы заинтересовать той или иной профессией</li>
              <li>Основные ошибки в профориентации, их последствия и способы исправления</li>
              <li>Как заинтересовать школьника тем или иным предметом, важным для будущей профессии</li>
            </ul>
            <div className={learn.btnWrap}>
              <div className={learn.img}>
                <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/photo-3.png" alt=""/>
              </div>
              <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться</button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
